module.exports = __webpack_public_path__ + "img/adele.91659ad3.jpg";